// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"fb88935e","711":"61acaad6"}[chunkId] + ".chunk.js";
};